module.exports = __webpack_public_path__ + "static/media/Phone_Card.d225fa80.svg";